import { RQAPICallWithData } from 'store/APIClient';
import { UserGroupSummaryT } from 'business/definitions';
import { useQuery } from '@tanstack/react-query';

const useGetUserGroups = (shouldFetch?: boolean) => {
    return useQuery({
        queryKey: ['getUserGroups', shouldFetch],

        queryFn: async () => {
            const response = await RQAPICallWithData<UserGroupSummaryT[]>({
                endpoint: 'auth/user_groups',
                method: 'GET',
            });
            return response.content.data;
        },

        enabled: shouldFetch,
    });
};

export default useGetUserGroups;
